import { Pill } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

import * as styles from "./LastUsedPill.styles";

const LastUsedPill = () => {
  const { t } = useTranslation();

  return (
    <Pill size="small" intention="info" customCss={styles.badge}>
      {t(l.signin.LastUsed)}
    </Pill>
  );
};

export { LastUsedPill };
